import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import AdminNavbar from "../Layout/AdminNavbar";
import { FaTrash } from "react-icons/fa";
import API_BASE_URL from "../config";

const AdminManageTeams = () => {
  const [myTeam, setMyTeam] = useState([]);
  const [teams, setTeams] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [projects, setProjects] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [filters, setFilters] = useState({ teamId: "", employeeId: "", reporterId: "" });

  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });

  const [formData, setFormData] = useState({
    teamId: "",
    employeeId: "",
    reporterId: "",
    projectId: "",
  });


  
  // Load data
  useEffect(() => {
  const fetchData = async () => {
    try {
      const token = localStorage.getItem("token"); // ⬅️ Get token

      const axiosConfig = {
        headers: {
          Authorization: `Bearer ${token}`, // ⬅️ Add token to all requests
        },
      };

      const [teamRes, empRes, projRes, myTeamRes] = await Promise.all([
        axios.get(`${API_BASE_URL}/api/teams`, axiosConfig),
        axios.get(`${API_BASE_URL}/api/employees/active`, axiosConfig),
        axios.get(`${API_BASE_URL}/api/projects`, axiosConfig),
        axios.get(`${API_BASE_URL}/api/manageteam`, axiosConfig),
      ]);

      setTeams(teamRes.data);
      setEmployees(empRes.data);
      setProjects(projRes.data);

      const mappedManageTeam = (myTeamRes.data || []).map(m => ({
        id: `${m.teamId}-${m.employeeId}`,

        team: {
          id: m.teamId,
          name: m.teamName,
        },

        employee: {
          id: m.employeeId,
          firstName: m.employeeFirstName,
          lastName: m.employeeLastName,
        },

        project: {
          name: m.projectName,
        },

        reporter: {
          id: m.reporterId,
          firstName: m.reporterFirstName,
          lastName: m.reporterLastName,
        },
      }));

      setMyTeam(mappedManageTeam);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load data.");
    }
  };

  fetchData();
}, []);



  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleFilterChange = (e) => setFilters({ ...filters, [e.target.name]: e.target.value });

  // Add team member
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE_URL}/api/manageteam`, formData);

      toast.success("Team Member added successfully!");

      setFormData({ teamId: "", employeeId: "", reporterId: "", projectId: "" });
      setShowForm(false);

      const res = await axios.get(`${API_BASE_URL}/api/manageteam`);
      setMyTeam(res.data);
    } catch (err) {
      toast.error(err.response?.data || "Something went wrong.");
    }
  };

  // Remove team member
  const handleRemove = async (employeeId) => {
    if (!window.confirm("Remove this member?")) return;

    try {
      await axios.delete(`${API_BASE_URL}/api/manageteam/${employeeId}`);
      setMyTeam((prev) => prev.filter((m) => m.employee?.id !== employeeId));
      toast.success("Member removed successfully");
    } catch (err) {
      toast.error(err.response?.data || "Error removing member.");
    }
  };

  // -------------------------------- FILTER --------------------------------
  let filteredTeam = myTeam.filter(
    (m) =>
      (!filters.teamId || m.team?.id === parseInt(filters.teamId)) &&
      (!filters.employeeId || m.employee?.id === parseInt(filters.employeeId)) &&
      (!filters.reporterId || m.reporter?.id === parseInt(filters.reporterId))
  );

  // -------------------------------- SORTING FIXED --------------------------------

  const sortData = (key) => {
    let direction = "asc";

    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    setSortConfig({ key, direction });
  };

  // helper to extract nested values based on key
  const getValue = (m, key) => {
    switch (key) {
      case "id":
        return m.id;
      case "employee":
        return m.employee?.firstName ?? "";
      case "designation":
        return m.employee?.designation ?? "";
      case "team":
        return m.team?.name ?? "";
      case "project":
        return m.project?.name ?? "";
      case "reporter":
        return m.reporter?.firstName ?? "";
      default:
        return "";
    }
  };

  if (sortConfig.key) {
    filteredTeam = [...filteredTeam].sort((a, b) => {
      const valA = getValue(a, sortConfig.key);
      const valB = getValue(b, sortConfig.key);

      if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }

  // Arrow icon logic
  const arrow = (key) =>
    sortConfig.key === key ? (sortConfig.direction === "asc" ? " ↑" : " ↓") : " ";

  // -------------------------------- UI --------------------------------

  return (
    <div className="vh-100 vw-100 d-flex flex-column">
      <AdminNavbar />

      <div className="container-fluid bg-light flex-grow-1" style={{ paddingTop: "30px", overflowY: "auto" }}>
        <div className="card shadow-sm border-0">
          <div className="card-header bg-light text-dark d-flex justify-content-between align-items-center">
            <h4 className="mb-0">👥 Manage Team</h4>
            <button className="btn btn-primary btn-sm" onClick={() => setShowForm(!showForm)}>
              {showForm ? "Close Form" : "Add Member"}
            </button>
          </div>

          {/* -------------------------- FORM -------------------------- */}
          {showForm && (
            <form onSubmit={handleSubmit} className="p-4 border rounded bg-white mb-4 shadow-sm">
              <div className="row g-3">
                {/* Team */}
                <div className="col-md-3">
                  <label className="form-label">Team</label>
                  <select
                    name="teamId"
                    value={formData.teamId}
                    onChange={handleChange}
                    className="form-select"
                    required
                  >
                    <option value="">Select Team</option>

                    {[...teams]
                      .sort((a, b) => a.name.localeCompare(b.name)) // ASC order
                      .map((t) => (
                        <option key={t.id} value={t.id}>
                          {t.name}
                        </option>
                      ))}
                  </select>

                </div>

                {/* Employee */}
                <div className="col-md-3">
                  <label className="form-label">Employee</label>
                  <select
                    name="employeeId"
                    value={formData.employeeId}
                    onChange={handleChange}
                    className="form-select"
                    required
                  >
                    <option value="">Select Employee</option>

                    {[...employees]
                      .sort((a, b) =>
                        `${a.firstName} ${a.lastName}`.localeCompare(
                          `${b.firstName} ${b.lastName}`
                        )
                      )
                      .map((e) => (
                        <option key={e.id} value={e.id}>
                          {e.firstName} {e.lastName}
                        </option>
                      ))}
                  </select>

                </div>

                {/* Reporter */}
                <div className="col-md-3">
                  <label className="form-label">Reporter</label>
                  <select
                    name="reporterId"
                    value={formData.reporterId}
                    onChange={handleChange}
                    className="form-select"
                    required
                  >
                    <option value="">Select Reporter</option>

                    {[...employees]
                      .sort((a, b) =>
                        `${a.firstName} ${a.lastName}`.localeCompare(
                          `${b.firstName} ${b.lastName}`
                        )
                      )
                      .map((r) => (
                        <option key={r.id} value={r.id}>
                          {r.firstName} {r.lastName}
                        </option>
                      ))}
                  </select>

                </div>

                {/* Project */}
                <div className="col-md-3">
                  <label className="form-label">Project</label>
                  <select
                    name="projectId"
                    value={formData.projectId}
                    onChange={handleChange}
                    className="form-select"
                    required
                  >
                    <option value="">Select Project</option>

                    {[...projects]
                      .sort((a, b) => a.name.localeCompare(b.name)) // ASC
                      .map((p) => (
                        <option key={p.id} value={p.id}>
                          {p.name}
                        </option>
                      ))}
                  </select>

                </div>
              </div>

              <div className="text-end mt-4">
                <button type="submit" className="btn btn-primary">
                  Save
                </button>
              </div>
            </form>
          )}

          {/* -------------------------- FILTERS -------------------------- */}
          <div className="p-3 border-bottom bg-light">
            <div className="row g-3">
              <div className="col-md-3">
                <select
                  name="teamId"
                  value={filters.teamId}
                  onChange={handleFilterChange}
                  className="form-select"
                >
                  <option value="">All Teams</option>

                  {[...teams]
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((t) => (
                      <option key={t.id} value={t.id}>
                        {t.name}
                      </option>
                    ))}
                </select>

              </div>

              <div className="col-md-3">
                <select
                  name="employeeId"
                  value={filters.employeeId}
                  onChange={handleFilterChange}
                  className="form-select"
                >
                  <option value="">All Employees</option>

                  {[...employees]
                    .sort((a, b) =>
                      `${a.firstName} ${a.lastName}`.localeCompare(
                        `${b.firstName} ${b.lastName}`
                      )
                    )
                    .map((e) => (
                      <option key={e.id} value={e.id}>
                        {e.firstName} {e.lastName}
                      </option>
                    ))}
                </select>

              </div>

              <div className="col-md-3">
                <select
                  name="reporterId"
                  value={filters.reporterId}
                  onChange={handleFilterChange}
                  className="form-select"
                >
                  <option value="">All Managers</option>

                  {[...employees]
                    .sort((a, b) =>
                      `${a.firstName} ${a.lastName}`.localeCompare(
                        `${b.firstName} ${b.lastName}`
                      )
                    )
                    .map((r) => (
                      <option key={r.id} value={r.id}>
                        {r.firstName} {r.lastName}
                      </option>
                    ))}
                </select>

              </div>
            </div>
          </div>

          {/* -------------------------- TABLE -------------------------- */}
          <div className="card-body flex-grow-1 overflow-auto">
            {filteredTeam.length === 0 ? (
              <div className="text-center py-5 text-muted fs-5">No team members found.</div>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover align-middle text-start mb-0">
                  <thead>
                    <tr>
                      <th onClick={() => sortData("id")} style={{ cursor: "pointer", background: "#DFE4EB" }}>
                        Sr {arrow("id")}
                      </th>

                      <th onClick={() => sortData("employee")} style={{ cursor: "pointer", background: "#DFE4EB" }}>
                        Employee {arrow("employee")}
                      </th>

                      {/* <th onClick={() => sortData("designation")} style={{ cursor: "pointer", background: "#DFE4EB" }}>
                        Designation {arrow("designation")}
                      </th> */}

                      <th onClick={() => sortData("team")} style={{ cursor: "pointer", background: "#DFE4EB" }}>
                        Team {arrow("team")}
                      </th>

                      <th onClick={() => sortData("project")} style={{ cursor: "pointer", background: "#DFE4EB" }}>
                        Project {arrow("project")}
                      </th>

                      <th onClick={() => sortData("reporter")} style={{ cursor: "pointer", background: "#DFE4EB" }}>
                        Manager {arrow("reporter")}
                      </th>

                      <th style={{ background: "#DFE4EB" }}>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredTeam.map((m, idx) => (
                      <tr key={m.id}>
                        <td>{idx + 1}</td>
                        <td>
                          {m.employee?.firstName} {m.employee?.lastName}
                        </td>
                        {/* <td>{m.employee?.designation || "—"}</td> */}
                        <td>{m.team?.name}</td>
                        <td>{m.project?.name}</td>
                        <td>
                          {m.reporter?.firstName} {m.reporter?.lastName}
                        </td>
                        <td>
                          <button className="btn btn-sm" onClick={() => handleRemove(m.employee?.id)}>
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminManageTeams;
